import { render } from "./EditClosureSummary.vue?vue&type=template&id=7460a686"
import script from "./EditClosureSummary.vue?vue&type=script&lang=js"
export * from "./EditClosureSummary.vue?vue&type=script&lang=js"

import "./EditClosureSummary.vue?vue&type=style&index=0&id=7460a686&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__